import './App.scss';
import React, { useEffect, useState, Suspense } from "react";

import { HOME_PAGE_DATA } from './assets/constants/app.constant.js';
import AppRoute from './config/routes/route';

import { AppContext, APP_CONSTANTS } from "./config/utils/AppContext";
import { getOS } from './config/utils/utils.js';
let TagManager = null;
function App() {
  import("react-gtm-module").then(({ default: tagmanager }) => {
    TagManager = tagmanager;
    setTimeout(() => {
      const device = JSON.parse(process.env.REACT_APP_DEVICE);
      const platform = getOS()
      const environment = process.env.REACT_APP_ENVIRONMENT;
      const appName = process.env.REACT_APP_GA_NAME;

      const urlParams = new URLSearchParams(window.location.search);

      const utmData = {
        utmSource: urlParams.get("utm_source"),
        utmMedium: urlParams.get("utm_medium"),
        utmCampaign: urlParams.get("utm_campaign"),
        utmContent: urlParams.get("utm_content"),
        utmTerm: urlParams.get("utm_term"),
      };

      const tagManagerArgs = {
        gtmId: "GTM-TDJBK5Z",
        dataLayer: {
          app_name: appName,
          env: environment,
          // ...device,
          platform: platform == 'browser' ? "browser" : "tira",
          brand:platform,
          ...utmData,
        },
      };
      TagManager.initialize(tagManagerArgs);
    });
  });


  return (
    <React.Fragment>
      <AppContext.Provider value={APP_CONSTANTS}>
        <AppRoute />

      </AppContext.Provider>
    </React.Fragment>
  );
}

export default App;
